import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../appRedux/actions/CoreServicesAction";
const Logout = (props) => {
  let navigate = useNavigate();
  useEffect(async () => {
    localStorage.removeItem("@token");
    await props.actions.OfflineCoreServices("token", "jwt", null);
    navigate("/profile");
  }, []);
  return <div>خروج</div>;
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
